import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomerServiceOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Result, Space } from "antd";
import { observer } from "mobx-react";
import { __ } from "../../../utils/i18n.js";
const FatalError = observer(({ error })=>{
    const { isBackendDown } = error;
    let title;
    let subTitle;
    if (isBackendDown) {
        title = __("Customer center service is temporarily unavailable");
        subTitle = __("This is on us and we're already looking into it. Please reload the page in a moment! If the issue persists, feel free to open a support ticket.");
    } else {
        title = __("Customer center couldn't be loaded");
        subTitle = error.message || __("Please reload the page to try again! If the issue persists, feel free to open a support ticket.");
    }
    return /*#__PURE__*/ _jsx(Result, {
        status: "warning",
        title: title,
        subTitle: subTitle,
        extra: /*#__PURE__*/ _jsxs(Space, {
            size: "middle",
            wrap: true,
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ _jsx(ReloadOutlined, {}),
                    onClick: ()=>window.location.reload(),
                    children: __("Reload page")
                }),
                /*#__PURE__*/ _jsx(Button, {
                    size: "large",
                    icon: /*#__PURE__*/ _jsx(CustomerServiceOutlined, {}),
                    href: __("https://devowl.io/support/"),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: __("Contact support")
                })
            ]
        })
    });
});
export { FatalError };
